import React, {Component} from 'react'
import {Popup, Button} from 'semantic-ui-react'
import ExportToExcel from './export-to-excel'
import ExportToPdf from './export-to-pdf'
import BulkEditCad from './bulk-edit'
import SettingsModal from './settings-modal'
import SelectAll from './select-all'
import {isCustomer, isAdmin, isSales, isSalesAssistant, isInventory} from '../cads/is-role'
import BulkMarkReviewedByBuyer from '../cad-buyer-reviews/bulk-modal'
import {getUpcExcel} from '../upc/get'

class BulkButtons extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  upcExcel = () => {
    let keys = Object.keys(this.props.cadIds)
    if (keys.length == 0) {
      alert('Please select at least 1 cad')
    } else {
      getUpcExcel(keys)
    }
  }

  render() {
    let {
      showFields, fieldOnChange, sortBy, expandAll, expandAllOnChange, searchString, showFieldOnChange, hideAllFields,
      shippedData, salesOrderData, cads, contact, contactOptions, fromDate, toDate, atsRep,
      selectAll, allSelected, cadIds, orgId, laFashionCombine, laFashionCombineOnChange, vendorOrders,
      markAsBestSeller, markAsAverageSeller, markAsPoorSeller, createSalesOrder
    } = this.props

    return (
      <div style={{position: 'fixed', left: 0, padding: '6px 3px', top: '50%', transform: 'translateY(-50%)', border: '1px solid rgb(230,230,230)', borderRadius: '2px', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05)'}}>
          <ExportToExcel showFields={showFields} showFieldOnChange={showFieldOnChange} hideAllFields={hideAllFields}
            shippedData={shippedData} salesOrderData={salesOrderData} cads={cads}
            contact={contact} fromDate={fromDate} toDate={toDate} atsRep={atsRep} cadIds={cadIds} fieldOnChange={fieldOnChange}
            sortBy={sortBy} searchString={searchString} vendorOrders={vendorOrders}
          />
        <br/>
        <ExportToPdf
          showFields={showFields}
          showFieldOnChange={showFieldOnChange}
          hideAllFields={hideAllFields}
          cadIds={cadIds}
          cads={cads}
          shippedData={shippedData}
          salesOrderData={salesOrderData}
          vendorOrders={vendorOrders}
          atsRep={atsRep}
          contact={contact}
          fromDate={fromDate}
          toDate={toDate}
        />
        <br/>

        {
          isCustomer()
          ?
          null
          :
          <React.Fragment>
            <BulkEditCad cadIds={cadIds} orgId={orgId}/>
            <br/>
            <Popup content='UPC Excel' position='right center' trigger={
              <Button onClick={this.upcExcel} basic circular icon='barcode' style={{marginTop: '2px'}}/>
            } />
            <br/>
          </React.Fragment>
        }

        <SettingsModal fieldOnChange={fieldOnChange} sortBy={sortBy}
          expandAll={expandAll} expandAllOnChange={expandAllOnChange}
          showFields={showFields} showFieldOnChange={showFieldOnChange}
          hideAllFields={hideAllFields} orgId={orgId} laFashionCombine={laFashionCombine}
          laFashionCombineOnChange={laFashionCombineOnChange}
        />

        {
          isAdmin() || isSales() || isSalesAssistant() || isInventory() || isCustomer()
          ?
          <React.Fragment>
            <br/>
            <Popup content='Mark as best seller' position='right center' trigger={
              <Button onClick={markAsBestSeller} basic circular icon='thumbs up outline' style={{marginTop: '2px'}}/>
            } />
            <br/>
            <Popup content='Mark as average seller' position='right center' trigger={
              <Button onClick={markAsAverageSeller} basic circular icon='smile outline' style={{marginTop: '2px'}}/>
            } />
            <br/>
            <Popup content='Mark as poor seller' position='right center' trigger={
              <Button onClick={markAsPoorSeller} basic circular icon='thumbs down outline' style={{marginTop: '2px'}}/>
            } />
            <br/>
          </React.Fragment>
          :
          null
        }

        {
          isAdmin() || isSales() || isSalesAssistant()
          ?
          <React.Fragment>
            <BulkMarkReviewedByBuyer cadIds={cadIds} numSelected={Object.keys(cadIds).length} salesHistoryAccounts={contactOptions}/>
            <br/>
            <Popup content='New sales order' position='right center' trigger={
              <Button onClick={createSalesOrder} basic circular icon='cart' style={{marginTop: '2px'}}/>
            } />
            <br/>
          </React.Fragment>
          :
          null
        }

        <SelectAll selectAll={selectAll} allSelected={allSelected}/>
        <center>{Object.keys(cadIds).length}</center>
      </div>
    )
  }
}

export default BulkButtons
